import { Deserializable } from '../../../lib/models/deserializable';

export class ApplicantEmploymentCompanyDirectorship implements Deserializable {
  public ApplicantEmploymentCompanyDirectorshipID: number;
  public EmploymentNumber?: number;
  public CompanyName: string;
  public ShareHoldingPercent?: number;
  public GeneratingIncomeCode: string;
  public AnyAdditionalDetails: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
